import { render, staticRenderFns } from "./foodEditPrice.vue?vue&type=template&id=26f3cde6&scoped=true"
import script from "./foodEditPrice.vue?vue&type=script&lang=js"
export * from "./foodEditPrice.vue?vue&type=script&lang=js"
import style0 from "./foodEditPrice.vue?vue&type=style&index=0&id=26f3cde6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f3cde6",
  null
  
)

export default component.exports